/* Ported from reference/salesfix-value-map-builder.html (class names in camelCase). The reference is the visual spec; edit here, not there. */
.setup {
  display: flex;
  gap: 26px;
  flex-wrap: wrap;
  align-items: flex-end;
  padding: 18px 26px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
}
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.field label {
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  letter-spacing: 0.02em;
}
.field input {
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 9px 11px;
  font-size: 15px;
  background: #fff;
}
.field input:focus,
textarea:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.field.org input {
  min-width: 280px;
  font-weight: 700;
}
.field.small input {
  min-width: 170px;
}
.layout {
  display: grid;
  grid-template-columns: 288px 1fr;
  gap: 0;
  align-items: start;
}
.rail {
  border-right: 1px solid var(--border);
  background: var(--surface);
  min-height: calc(100vh - 130px);
  padding: 22px 18px;
  position: sticky;
  top: 61px;
}
.rail h2 {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--muted);
  margin-bottom: 12px;
}
.goalList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}
.goalChip {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  width: 100%;
  border: 1px solid var(--border);
  background: #fff;
  border-radius: 10px;
  padding: 11px 12px;
  color: var(--ink);
  font-weight: 700;
  font-size: 14px;
  transition: all 0.15s ease;
}
.goalChip:hover {
  border-color: var(--blue-l);
}
.goalChip[aria-current="true"] {
  border-color: var(--blue-d);
  box-shadow: inset 3px 0 0 var(--green-l);
  background: #f3fafc;
}
.goalChip .num {
  flex: 0 0 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--bg);
  color: var(--blue-d);
  font-size: 12px;
  font-weight: 900;
  display: grid;
  place-items: center;
}
.goalChip .txt {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.goalChip .dots {
  display: inline-flex;
  gap: 3px;
  flex: 0 0 auto;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--border-strong);
}
.dot.on {
  background: var(--green-d);
}
.addGoal {
  width: 100%;
  border: 1px dashed var(--border-strong);
  background: transparent;
  color: var(--blue-text);
  font-weight: 700;
  padding: 11px;
  border-radius: 10px;
}
.addGoal:hover {
  border-color: var(--blue-l);
  background: #f3fafc;
}
.railNote {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
  font-size: 12.5px;
  color: var(--muted);
}
.railNote strong {
  color: var(--body);
}
.legend {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.legend .li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--muted);
}
.legend .sw {
  width: 12px;
  height: 12px;
  border-radius: 4px;
  flex: 0 0 auto;
}
.canvas {
  padding: 30px 34px 80px;
  max-width: 1000px;
}
.empty {
  text-align: center;
  padding: 70px 20px;
  color: var(--muted);
}
.empty h2 {
  font-size: 24px;
  margin-bottom: 10px;
}
.empty p {
  max-width: 460px;
  margin: 0 auto 22px;
}
.goalHead {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 6px;
}
.goalTitleInput {
  flex: 1 1 auto;
  border: none;
  border-bottom: 2px solid var(--border);
  background: transparent;
  font-size: 27px;
  font-weight: 900;
  letter-spacing: -0.02em;
  color: var(--ink);
  padding: 4px 2px 8px;
}
.goalTitleInput::placeholder {
  color: var(--border-strong);
}
.goalTitleInput:focus {
  outline: none;
  border-bottom-color: var(--green-l);
}
.delGoal {
  border: none;
  background: transparent;
  color: var(--muted);
  font-weight: 700;
  font-size: 13px;
  padding: 8px;
  border-radius: 8px;
}
.delGoal:hover {
  color: #c0392b;
  background: #fbedea;
}
.whoRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin: 14px 0 26px;
}
.whoBox {
  background: #f3fafc;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
}
.whoBox label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--blue-text);
  margin-bottom: 6px;
}
.whoBox input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 15px;
}
.whoBox input:focus {
  outline: none;
}
/* The input has no border of its own, so the box shows where focus is (WCAG 2.4.7). */
.whoBox:focus-within {
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.chain {
  position: relative;
  margin-left: 8px;
  padding-left: 40px;
}
.chain::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 12px;
  bottom: 40px;
  width: 2px;
  background: linear-gradient(var(--blue-l), var(--green-l));
}
.step {
  position: relative;
  margin-bottom: 22px;
}
.step .marker {
  position: absolute;
  left: -40px;
  top: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--surface);
  border: 2px solid var(--blue-l);
  color: var(--blue-d);
  font-weight: 900;
  font-size: 14px;
  display: grid;
  place-items: center;
  z-index: 2;
}
.step.impact .marker {
  border-color: var(--green-d);
  color: var(--green-text);
}
.step .q {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
}
.step h3 {
  font-size: 18px;
  margin: 2px 0 9px;
}
.step textarea {
  width: 100%;
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  padding: 12px 13px;
  font-size: 15px;
  line-height: 1.5;
  background: #fff;
  min-height: 62px;
  /* Grow to fit the text, then scroll (issue #6). useAutoGrow covers browsers without it. */
  field-sizing: content;
  max-height: 60vh;
  overflow-y: auto;
}
.step textarea::placeholder {
  color: #a9bec8;
}
.levers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
}
.lever {
  border: 1px solid var(--border-strong);
  border-radius: 11px;
  overflow: hidden;
  background: #fff;
  transition: border-color 0.15s ease;
}
.lever.on {
  border-color: var(--green-d);
  box-shadow: 0 0 0 1px var(--green-d);
}
.lever .toggle {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  padding: 13px 14px;
}
.lever .check {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid var(--border-strong);
  display: grid;
  place-items: center;
  margin-top: 1px;
  transition: all 0.15s ease;
}
.lever.on .check {
  background: var(--green-d);
  border-color: var(--green-d);
}
.lever .check svg {
  width: 12px;
  height: 12px;
  opacity: 0;
}
.lever.on .check svg {
  opacity: 1;
}
.lever .lvTitle {
  font-weight: 700;
  color: var(--ink);
  font-size: 14.5px;
}
.lever .lvHelp {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
  line-height: 1.4;
}
.lever .measure {
  padding: 0 14px 13px 45px;
}
.lever .measure input {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13.5px;
  background: #f7fbfd;
}
.lever .measure input::placeholder {
  color: #a9bec8;
}
.lever .lvNameInput {
  border: none;
  background: transparent;
  font-weight: 700;
  font-size: 14.5px;
  color: var(--ink);
  width: 100%;
}
.lever .lvNameInput:focus {
  outline: none;
  border-bottom: 1px solid var(--green-l);
}
.addLever {
  grid-column: 1 / -1;
  border: 1px dashed var(--border-strong);
  background: transparent;
  color: var(--blue-text);
  font-weight: 700;
  padding: 10px;
  border-radius: 10px;
}
.addLever:hover {
  background: #f3fafc;
  border-color: var(--blue-l);
}
.rmLever {
  border: none;
  background: transparent;
  color: var(--muted);
  font-size: 12px;
  font-weight: 700;
  padding: 4px 8px;
}
.rmLever:hover {
  color: #c0392b;
}
.coi {
  margin-top: 26px;
  background: var(--amber-bg);
  border: 1px solid var(--amber-line);
  border-left: 5px solid var(--amber-line);
  border-radius: 11px;
  padding: 15px 17px;
}
.coi .q {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--amber-text);
}
.coi h3 {
  color: var(--amber-text);
  font-size: 16px;
  margin: 2px 0 9px;
}
.coi textarea {
  width: 100%;
  border: 1px solid var(--amber-line);
  border-radius: 9px;
  padding: 11px 12px;
  font-size: 15px;
  background: #fff;
  min-height: 54px;
  field-sizing: content;
  max-height: 60vh;
  overflow-y: auto;
}
.readback {
  margin-top: 26px;
  background: var(--blue-d);
  color: #eaf6fb;
  border-radius: var(--radius);
  padding: 20px 22px;
}
.readback .eyebrow {
  color: var(--green-on-dark);
}
.rbBeats {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.rbBeat {
  display: flex;
  gap: 14px;
  align-items: baseline;
}
.rbLabel {
  flex: 0 0 82px;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--green-on-dark);
}
.rbBody {
  flex: 1 1 auto;
  font-size: 16.5px;
  line-height: 1.55;
  color: #eaf6fb;
}
.rbBody .hl {
  color: #fff;
  font-weight: 700;
}
.rbCost {
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  font-size: 14px;
  color: #cde8f2;
}
.rbCost span {
  color: var(--amber-on-dark);
  font-weight: 700;
}
.rbEmpty {
  color: #9fcadd;
  font-style: italic;
  margin-top: 8px;
}
@media (max-width: 820px) {
  .layout {
    grid-template-columns: 1fr;
  }
  .rail {
    position: static;
    min-height: 0;
    border-right: none;
    border-bottom: 1px solid var(--border);
  }
  .levers,
  .whoRow {
    grid-template-columns: 1fr;
  }
  .canvas {
    padding: 22px 18px 60px;
  }
  .rbBeat {
    flex-direction: column;
    gap: 3px;
  }
  .rbLabel {
    flex-basis: auto;
  }
}
